globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { PhotoIcon } from '@heroicons/react/24/outline';
import { jsx as _jsx } from "react/jsx-runtime";
export function ImagePlaceholder(_ref) {
  var wrapperStyle = _ref.wrapperStyle,
      _ref$iconClasses = _ref.iconClasses,
      iconClasses = _ref$iconClasses === void 0 ? '' : _ref$iconClasses,
      Icon = _ref.Icon;
  var currentIconClasses = iconClasses || 'h-6 w-6 fill-purple-700';
  var ImageIcon = Icon || PhotoIcon;
  return /*#__PURE__*/_jsx(Wrapper, {
    twStyle: wrapperStyle,
    children: /*#__PURE__*/_jsx(ImageIcon, {
      className: currentIconClasses
    })
  });
}
export default ImagePlaceholder;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "image-placeholder__Wrapper",
  componentId: "sc-1raqb3a-0"
})(["", ";", ""], {
  "display": "grid",
  "height": "4rem",
  "width": "4rem",
  "placeItems": "center",
  "overflow": "hidden",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
}, function (_ref2) {
  var twStyle = _ref2.twStyle;
  return twStyle;
});